import { Component } from '@angular/core';
import { TunnelStep } from '../../../models/tunnel-step.model';

@Component({
  selector: 'jhi-my-bills',
  templateUrl: './my-bills.component.html',
})
export class MyBillsComponent {
  steps: TunnelStep[] = [];
  active = 1;

  constructor() {
    this.steps = [
      { title: 'bills.title', url: '/user/my-bills/bills', idCypress: 'bills' },
      { title: 'refund.title', url: '/user/my-bills/refunds', idCypress: 'refunds' },
    ] as TunnelStep[];
  }
}
